import styled from '@emotion/styled'
import { hexColors } from '@mobi/settings'

export interface SingleSilkImageProps {
  isDogsSilk: boolean
}

export const SingleSilkImageStyled = styled.img<SingleSilkImageProps>(({ isDogsSilk }) => {
  return {
    maxWidth: '3rem',
    minWidth: '1rem',
    height: 'fit-content',
    boxSizing: 'border-box',
    border: (isDogsSilk && `1px solid ${hexColors.nero}`) || undefined,
  }
})
